import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { safeDispatchEvent, safeLocalStorageGet, safeLocalStorageSet } from "@/lib/safe-browser";

const KEY = "routify_cookie_consent";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!safeLocalStorageGet(KEY)) setShow(true);
    } catch { /* ignore */ }
  }, []);

  function decide(value: "accepted" | "essential") {
    safeLocalStorageSet(KEY, value);
    safeDispatchEvent(new CustomEvent("routify-consent-change", { detail: value }));
    setShow(false);
  }

  if (!show) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-2xl rounded-xl border border-border bg-card/95 p-4 shadow-xl backdrop-blur">
      <p className="text-sm text-foreground">
        We use essential storage to remember your language and preferences. Map tiles
        from Google Maps may set their own cookies when you interact with the map.
        See our <Link to="/cookies" className="underline">Cookie Policy</Link> and{" "}
        <Link to="/privacy" className="underline">Privacy Policy</Link>.
      </p>
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <button
          onClick={() => decide("essential")}
          className="rounded-md border border-input bg-background px-3 py-1.5 text-sm hover:bg-accent"
        >
          Essential only
        </button>
        <button
          onClick={() => decide("accepted")}
          className="rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Accept all
        </button>
      </div>
    </div>
  );
}
